import React from "react";
import styled from "@emotion/styled";
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

const Content = styled.div`
  padding: 10px;
  font-size: 14px;
  line-height: 1.3;
  & h3 {
    color: #696969ff;
  }
`;

function NotActive(props) {
  const { device } = props;
  const { lastSeen, id } = device;

  let time = lastSeen ? new Date(lastSeen * 1000).toLocaleTimeString().substring(0, 5) : "";
  if (time && time[0] === "0") {
    time = time.substring(1);
  }

  let date = lastSeen ? new Date(lastSeen * 1000).toLocaleDateString() : "";
  if (date && date[0] === "0") {
    date = date.substring(1);
  }

  let message;
  if (device.caqi) {
    message = "Przepraszamy, raport niedostępny. Zbyt mała ilość danych.";
  } else {
    message = lastSeen
      ? `Przepraszamy, czujnik nieaktywny. Ostatnie dane z czujnika zarejestrowano ${date} o godz. ${time}.`
      : "Przepraszamy, brak danych.";
  }
  return (
    <Content>
      {Boolean(device.caqi) && <h3>Przepraszamy, raport niedostępny. Zbyt mała ilość danych.</h3>}
      {!Boolean(device.caqi) &&
        (Boolean(lastSeen) ? (
          <Card>
            <Alert severity="error">Przepraszamy, czujnik nieaktywny.</Alert>
            <CardContent>
              Ostatnie dane z czujnika zarejestrowano {date} o godz. {time}.
              <br />
              <br /> - ID: {device.id}
              <br />- Dostawca: {device.provider ? device.provider : "Brak danych"}
              <br />- ID dostawcy: {device.deviceId}
              <br />- Lokalizacja: {device.lat}, {device.lng}
            </CardContent>
          </Card>
        ) : (
          <h3>Przepraszamy, brak danych.</h3>
        ))}
    </Content>
  );
}

export default NotActive;
